import { useRouter } from 'next/router';

import { breakpoints } from '@r1-frontend/entities/Layout/Header/types';

import { Profile } from '@r1-frontend/ui-kit/atoms/svg/users';
import { Text } from '@r1-frontend/ui-kit/atoms/typography/text';
import { USER_LOGIN_ROUTE } from '@r1-frontend/shared/constants/routes';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';
import { useRouterAsPath } from '@r1-frontend/shared/hooks/useRouterAsPath';

import { MenuButton } from './MenuButton';

export const LoginButton = () => {
    const router = useRouter();
    const asPath = useRouterAsPath();
    const isSmallMobile = useMatchMediaByWidth(breakpoints.mMobile);

    const handleLogin = () => {
        router.push(`${USER_LOGIN_ROUTE}?referrer=${decodeURIComponent(asPath)}`);
    };
    return (
        <MenuButton onClick={handleLogin} data-test='auth-link'>
            <Profile size={isSmallMobile ? 24 : 20}/>
            {!isSmallMobile && (
                <Text $color={'head'} $size={'md'} $weight={'medium'}>Войти</Text>
            )}
        </MenuButton>
    );
};
